import React, { Component, ReactElement, }  from "react";
import { Button, classNames, ButtonColor, ButtonStyle, ButtonProps, Dropdown, DropdownProps, parseClasses, } from ".";

// styling
import "./style.scss";


interface Props {
    buttonProps: ButtonProps;
    dropdownProps: DropdownProps;

    className?: string | string[];
    disabled?: boolean;
    color?: ButtonColor;
    style?: ButtonStyle;
}

interface State {
    isExpanded: boolean;
}

/*
    TODO: support opening upwards!
*/

export class SplitButton extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isExpanded: false,
        };

        // method binding
    }

    public render(): ReactElement {
        const { buttonProps, dropdownProps, className, color, style, disabled, } = this.props;
        const { isExpanded, } = this.state;

        const containerCss = classNames([
            "btn-group",
            parseClasses(className),
            "__splitbutton__",
        ]);

        const actionButton = (
            <Button color={color} style={style} {...buttonProps} disabled={disabled}>
                {buttonProps.children}
            </Button>
        );

        const toggleCss = classNames([
            "dropdown-toggle",
            "dropdown-toggle-split",
            (isExpanded && "show"),
            "__splitbuttontoggle__",
        ]);
        const handleToggleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            const expanded = !isExpanded;
            this.setState({
                isExpanded: expanded,
            });
            // stop propagation to prevent the document
            // click event from firing, which by now has
            // been registered to close the dropdown via
            // Dropdown.tsx's componentDidMount()
            e.stopPropagation();
        };
        const toggleButton = (
            <Button
                className={toggleCss}
                onClick={handleToggleClick}
                disabled={disabled}
                color={color}
                style={style}
            />
        );

        const handleDropdownDismiss = () => {
            dropdownProps.onDismiss && dropdownProps.onDismiss();

            this.setState({
                isExpanded: false,
            });
        };
        const dropdown = (
            <Dropdown {...dropdownProps} onDismiss={handleDropdownDismiss}>
                {dropdownProps.children}
            </Dropdown>
        );

        return (
            <div className={containerCss}>
                {actionButton}
                {toggleButton}
                {isExpanded && dropdown}
            </div>
        );
    }
}

/*
export const SplitButton: FC<Props> = (props): ReactElement => {
    const { buttonProps, dropdownProps, containerClassName, } = props;

    const containerCss = classNames([
        "btn-group",
        containerClassName ? (Array.isArray(containerClassName) ? classNames([...containerClassName]) : containerClassName) : null,
        "__splitbutton__",
    ]);

    const actionButton = (
        <Button {...buttonProps}>
            {buttonProps.children}
        </Button>
    );

    const toggleCss = classNames([
        "dropdown-toggle",
        "dropdown-toggle-split",
        // (expanded && "show"),
        "__splitbuttontoggle_",
    ]);
    const toggleButton = (
        <Button
            className={toggleCss}
        />
    );

    const dropdown = (
        <Dropdown {...dropdownProps}>
            {dropdownProps.children}
        </Dropdown>
    );

    return (
        <div className={containerCss}>
            {actionButton}
            {toggleButton}
            {dropdown}
        </div>
    );
}
*/